import { UserType } from './userBasedBackendTypes';

type UserTypeFields = { customer: unknown; suppliers: readonly unknown[]; actor?: { type: string } };

/** Whose user `GET /my/details` describes: a supplier's user or contact, a customer's user, or the tenant's own. */
export function userTypeOf(details: UserTypeFields): UserType {
    if (details.suppliers.length > 0) {
        return UserType.Supplier;
    }
    if (details.customer !== null) {
        return UserType.Customer;
    }
    return UserType.Internal;
}

/** The tenant's own staff, signed in themselves: a machine token acting for one doesn't count. */
export function isSignedInStaff(details: UserTypeFields): boolean {
    return userTypeOf(details) === UserType.Internal && details.actor?.type !== 'machine';
}
